<template>
  <div class="html_combatTeamForTop" ref="html_combatTeamForTop">
    <div class="main">
      <template v-if="datas.objectInfo && datas.objectInfo.length == 2">
        <div class="top_box">
          <span class="combat_infor">
            <span class="combat_team combat_left">
              <span class="teamLogo">
                <img :src="datas.objectInfo[0].teamLogo" />
              </span>
              <span
                class="teamName"
                v-text="datas.objectInfo[0].teamName"
              ></span>
            </span>

            <span class="combat_center">
              <span
                class="homeScore"
                v-text="datas.objectInfo[0].teamScore"
              ></span>
              <span class="vs" v-text="'-'"></span>
              <span
                class="awayScore"
                v-text="datas.objectInfo[1].teamScore"
              ></span>
            </span>
            <span class="combat_team combat_right">
              <span class="teamLogo">
                <img :src="datas.objectInfo[1].teamLogo" />
              </span>
              <span
                class="teamName"
                v-text="datas.objectInfo[1].teamName"
              ></span>
            </span>
          </span>
        </div>
      </template>
      <template v-else-if="datas.data && datas.data.matchInfo">
        <span
          class="matchName"
          v-text="datas.data.matchInfo.scheduleName"
        ></span>
      </template>
      <div
        class="table_box"
        :class="
          !datas.objectInfo &&
          datas.objectInfo.length === 0 &&
          !datas.data.matchInfo
            ? 'pureTable'
            : ''
        "
      >
        <span class="t_body">
          <span class="customTable_row">
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
              v-text="columnItem.name"
            ></span>
          </span>
          <span
            class="customTable_row"
            v-for="(rowData, rowIndex) in datas.data.dataList"
            :key="rowIndex"
          >
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
            >
              <NumberScrolling
                :tarVal="rowData[columnItem.statisticalEn]"
                :unit="columnItem.suffix"
              ></NumberScrolling>
            </span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 上面 团体对阵  + 下面 table表格
import NumberScrolling from '../components/NumberScrolling'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_combatTeamForTop',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    NumberScrolling,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [], //优先读 objectInfo , 没有 objectInfo 后再考虑 matchInfo
        data: {
          dataList: [],
          matchInfo: null, //matchInfo不存在时，matchInfo字段不存在
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {
      // themetype: 'A', //A:单人；D:双人；T:团队
      // sportType: 'uncombat', //combat: 对抗； uncombat:非对抗
      // datas: {
      //   objectInfo: [
      //     {
      //       teamName: '中国',
      //       teamNameEn: '',
      //       teamId: 'CHN',
      //       teamLogo:
      //         'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/CHN.png',
      //       teamScore: '',
      //       winFlag: '0',
      //       competitorId: null,
      //       phaseName: '',
      //       playerInfos: [],
      //     },
      //     {
      //       teamName: '美国',
      //       teamNameEn: '',
      //       teamId: 'USA',
      //       teamLogo:
      //         'https://hyper-sports-res.mixtmt.com/Games/ASG19/organisations/CHN.png',
      //       teamScore: '',
      //       winFlag: '0',
      //       competitorId: null,
      //       phaseName: '',
      //       playerInfos: [],
      //     },
      //   ],
      //   templateId: 3046,
      //   statisticsModels: [
      //     {
      //       id: 30073,
      //       name: '阶段',
      //       tableName: null,
      //       columnName: null,
      //       type: null,
      //       sort: 1,
      //       statisticalEn: 'phaseAbbr',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 30075,
      //       name: '队伍1',
      //       tableName: null,
      //       columnName: null,
      //       type: null,
      //       sort: 2,
      //       statisticalEn: 'team1',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 30076,
      //       name: '比分1',
      //       tableName: null,
      //       columnName: null,
      //       type: null,
      //       sort: 3,
      //       statisticalEn: 'score1',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 30078,
      //       name: '比分2',
      //       tableName: null,
      //       columnName: null,
      //       type: null,
      //       sort: 4,
      //       statisticalEn: 'score2',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 30077,
      //       name: '队伍2',
      //       tableName: null,
      //       columnName: null,
      //       type: null,
      //       sort: 5,
      //       statisticalEn: 'team2',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //   ],
      //   analysisItemId: 'd8adc3dbc8144f72bce0011e9e028450',
      //   competitionId: 'ASG',
      //   seasonId: 'ASG19',
      //   disciplineId: null,
      //   disciplineName: null,
      //   disciplineNameEn: null,
      //   eventId: null,
      //   eventName: null,
      //   eventNameEn: null,
      //   phaseId: null,
      //   graphicsId: 3012,
      //   title: '夺冠之路',
      //   data: {
      //     dataList: [
      //       {
      //         unit_code: 'VVOWTEAM6-------------GPA-000200--',
      //         phaseAbbr: '预赛A组',
      //         team1: '中国',
      //         score1: 3,
      //         team2: '印度',
      //         score2: 0,
      //       },
      //       {
      //         unit_code: 'VVOWTEAM6-------------GPA-000300--',
      //         phaseAbbr: '预赛A组',
      //         team1: '朝鲜',
      //         score1: 0,
      //         team2: '中国',
      //         score2: 3,
      //       },
      //       {
      //         unit_code: 'VVOWTEAM6-------------GPE-000200--',
      //         phaseAbbr: '排位赛E组',
      //         team1: '中国',
      //         score1: 3,
      //         team2: '越南',
      //         score2: 0,
      //       },
      //       {
      //         unit_code: 'VVOWTEAM6-------------GPE-000600--',
      //         phaseAbbr: '排位赛E组',
      //         team1: '中国',
      //         score1: 3,
      //         team2: '朝鲜',
      //         score2: 0,
      //       },
      //       {
      //         unit_code: 'VVOWTEAM6-------------GPE-000400--',
      //         phaseAbbr: '排位赛E组',
      //         team1: '中国',
      //         score1: 3,
      //         team2: '韩国',
      //         score2: 0,
      //       },
      //       {
      //         unit_code: 'VVOWTEAM6-------------SFNL000200--',
      //         phaseAbbr: '半决赛',
      //         team1: '中国',
      //         score1: 3,
      //         team2: '中国香港',
      //         score2: 0,
      //       },
      //       {
      //         unit_code: 'VVOWTEAM6-------------FNL-000100--',
      //         phaseAbbr: '决赛',
      //         team1: '韩国',
      //         score1: 0,
      //         team2: '中国',
      //         score2: 3,
      //       },
      //     ],
      //   },
      //   limitCount: null,
      //   json: null,
      //   seasonOrMatch: false,
      //   haveCdvPackage: false,
      //   needPicture: false,
      //   needMax: false,
      // },
    }
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    // themetype() {
    //   let themeType = ''
    //   const len = this.datas.objectInfo.length
    //   if (len === 0) {
    //     themeType = 'T'
    //   } else if (len === 1) {
    //     themeType = 'A'
    //   } else if (len === 2) {
    //     themeType = 'D'
    //   }
    //   return themeType
    // },
    // sportType() {
    //   let sportType = ''
    //   const len = this.datas.data.dataList[0].showDataList.length
    //   if (len === 1) {
    //     sportType = 'uncombat'
    //   } else if (len === 2) {
    //     sportType = 'combat'
    //   }
    //   return sportType
    // },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_combatTeamForTop {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 94%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .top_box {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .combat_infor {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: flex-start;
        margin-bottom: 0.694vw;
        .combat_team {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          width: calc(50% - 4.17vw);
          .teamLogo {
            position: relative;
            width: 2.7vw;
            height: 1.8vw;
            overflow: hidden;
            &::before {
              content: '\20';
              position: absolute;
              left: 0;
              top: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              border: 1px solid var(--mixtmt_greyColor5);
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .teamName {
            padding-top: 0.347vw;
            width: 100%;
            word-break: break-word;
            text-align: center;
            font-size: 0.972vw;
            line-height: 1.38vw;
            color: var(--mixtmt_greyColor2);
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
        .combat_center {
          padding-top: 0.068vw;
          width: 8.34vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          background-color: var(--mixtmt_greyColor7);
          border-radius: 0.278vw;
          .homeScore,
          .awayScore {
            width: calc(50% - 0.972vw);
            font-size: 1.38vw;
            line-height: 2.083vw;
            color: var(--mixtmt_greyColor3);
            /* &.win {
                  color: var(--mixtmt_greyColor3);
                } */
          }
          .homeScore {
            text-align: right;
          }
          .vs {
            width: 1.944vw;
            font-size: 1.66vw;
            line-height: 2.083vw;
            color: var(--mixtmt_greyColor4);
            text-align: center;
          }
          .awayScore {
            text-align: left;
          }
        }
      }
    }
    .matchName {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 0.694vw;
      width: 100%;
      height: 1.8vw;
      font-size: 0.972vw;
      font-weight: bold;
    }
    .table_box {
      position: relative;
      height: auto;
      display: table;
      width: 100%;
      /* .t_header {
          width: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          .customTable_row {
            display: table-row;
            height: 2.083vw;
            color: var(--mixtmt_greyColor4);
            width: 100%;
            background: linear-gradient(
              180deg,
              var(--mixtmt_theme_defaultGradient_1_1) 0%,
              var(--mixtmt_theme_defaultGradient_1_2) 98%
            );
            color: var(--mixtmt_whiteColor);
            border-bottom: 0;
            .customTable_row_cell {
              font-size: 0.972vw;
              border-bottom: 0;
            }
          }
        } */
      &.pureTable {
        .t_body {
          max-height: 15.9vw;
        }
      }
      .t_body {
        width: 100%;
        height: auto;
        /* display: table; */
        display: block;
        max-height: 13.8vw;
        overflow: auto;
      }

      .customTable_row {
        display: table-row;
        height: 2.083vw;
        color: var(--mixtmt_greyColor4);
        &:first-child {
          position: sticky;
          top: 0;
          right: 3%;
          z-index: 2;
          display: table-row;
          height: 2.083vw;
          color: var(--mixtmt_greyColor4);
          width: 100%;
          background: linear-gradient(
            180deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          border-bottom: 0;
          .customTable_row_cell {
            font-size: 0.972vw;
            border-bottom: 0;
          }
        }
      }

      .customTable_row_cell {
        display: table-cell;
        padding: 0.486vw 0;
        font-size: 0.833vw;
        line-height: 1.11vw;
        font-weight: bold;
        text-align: center;
        width: 5%;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        vertical-align: middle;
      }
    }
  }
}
</style>
